import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Container, Row, Col, Input, Table, Button, Collapse, Alert } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { RowItem } from '../layout/RowItem';
import authService from '../api-authorization/AuthorizeService';
import Session from '../auth/Session'
import AdminFunctions from './AdminFunctions';

function RoleDetails(props) {

    const navigate = useNavigate();

    const [roleId, setRoleId] = useState('');
    const [roleName, setRoleName] = useState('');
    const [addPool, setAddPool] = useState([]);
    const [removePool, setRemovePool] = useState([]);
    const [addUser, setAddUser] = useState(null);
    const [removeUser, setRemoveUser] = useState(null);
    const [showAddSection, setShowAddSection] = useState(false);
    const [showRemoveSection, setShowRemoveSection] = useState(false);
    const [success, setSuccess] = useState(undefined);


    useEffect(() => {
        async function fetchIsAdmin() {
            const isAdmin = AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                navigate('/accessdenied');
            } else {
                if (props.location !== undefined && props.location.state !== undefined) {
                    if (props.location.state.existingRole) {
                        const roleId = props.location.state.roleId;
                        setRoleId(roleId)
                        getRoleDetails(roleId);
                    }
                }
                else {
                    navigate('/admin/roles/create');
                }
            }
        }
        fetchIsAdmin();
    })

    const getRoleDetails = async (roleId) => {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetRoleDetailsAsync?roleId=${roleId}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setState({
            roleName: data.name,
            addPool: data.addPool,
            removePool: data.removePool
        });
    }

    const renameRole = async () => {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/RenameRoleAsync?roleId=${roleId}&roleName=${roleName}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setSuccess(data);
        await getRoleDetails(roleId);
    }

    const addUserToRole = async () => {
        const token = Session.getToken();
        const userId = addUser[0].id;
        const response = await fetch(`api/Admin/AddUserToRoleAsync?userId=${userId}&roleId=${roleId}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setAddUser(null);
        setSuccess(data);
        await getRoleDetails(roleId);
    }

    const removeUserFromRole = async () => {
        const token = Session.getToken();
        const userId = removeUser[0].id;
        const response = await fetch(`api/Admin/RemoveUserFromRoleAsync?userId=${userId}&roleId=${roleId}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setRemoveUser(null);
        setSuccess(data);
        await getRoleDetails(roleId);
    }


    return (
        <div>
            <Container style={{ marginTop: '50px' }}>
                <RowItem>
                    <Col xl='12'>
                        <h3>Role Details</h3>
                    </Col>
                    <Col xl='8'>
                        <h6>Role Id: {roleId}</h6>
                    </Col>
                    <Col xl='4'>
                        <Button
                            color='primary'
                            onClick={() => setShowAddSection(!showAddSection)}
                            disabled={!addPool.length > 0 ? true : false}
                            style={{ marginRight: '20px' }}
                        >
                            {!showAddSection ? 'Add Users' : 'Hide'}
                        </Button>

                        <Button
                            color='danger'
                            onClick={() => setShowRemoveSection(!showRemoveSection)}
                            disabled={!removePool.length > 0 ? true : false}
                        >
                            {!showRemoveSection ? 'Remove Users' : 'Hide'}
                        </Button>
                    </Col>
                </RowItem>
                <RowItem>
                    <Col xl='12'>
                        <h6>Edit Role Name</h6>
                    </Col>
                    <Col xl='10'>
                        <Input
                            type='text'
                            name='roleName'
                            id='roleName'
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)}
                            disabled={roleId === AdminFunctions.AdminRoleId ? true : false}
                        />
                    </Col>
                    <Col xl='2'>
                        <Button
                            color='primary'
                            onClick={() => renameRole()}
                            disabled={roleId === AdminFunctions.AdminRoleId ? true : false}
                        >
                            Save
                        </Button>
                    </Col>
                </RowItem>
                <Collapse isOpen={showAddSection}>
                    <RowItem>
                        <Col xl='12'>
                            <Button
                                close
                                onClick={() => setShowAddSection(!showAddSection)}
                                style={{ float: 'right' }}
                            />
                        </Col>
                        <Col xl='12'>
                            <h6>Add Users to Role</h6>
                        </Col>
                        <Col xl='10'>
                            <Typeahead
                                id='addUser'
                                onChange={(selected) => setAddUser(selected)}
                                selected={addUser}
                                labelKey='name'
                                options={addPool}
                                placeholder='Search'
                            />
                        </Col>
                        <Col xl='2'>
                            <Button
                                color='primary'
                                onClick={() => addUserToRole()}
                                disabled={!addUser ? true : false}
                            >
                                Add
                            </Button>
                        </Col>
                    </RowItem>
                </Collapse>
                <Collapse isOpen={showRemoveSection}>
                    <RowItem>
                        <Col xl='12'>
                            <Button
                                close
                                onClick={() => setShowRemoveSection(!showRemoveSection)}
                                style={{ float: 'right' }}
                            />
                        </Col>
                        <Col xl='12'>
                            <h6>Remove Users from Role</h6>
                        </Col>
                        <Col xl='10'>
                            <Typeahead
                                id='removeUser'
                                onChange={(selected) => setRemoveUser(selected)}
                                selected={removeUser}
                                labelKey='name'
                                options={removePool}
                                placeholder='Search'
                            />
                        </Col>
                        <Col xl='2'>
                            <Button
                                color='danger'
                                onClick={() => removeUserFromRole()}
                                disabled={!removeUser ? true : false}
                            >
                                Remove
                            </Button>
                        </Col>
                    </RowItem>
                </Collapse>
                {removePool.length > 0 && (
                    <RowItem>
                        <Col xl='12' style={{ marginTop: '20px' }}>
                            <h6>Users in Role</h6>
                        </Col>
                        <Col xl='12'>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {removePool.map((ra, i) => {
                                        return (
                                            <tr key={ra.id}>
                                                <td>{ra.id}</td>
                                                <td>{ra.name}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </RowItem>
                )}
                <Row style={{ marginTop: '20px' }}>
                    <Col xl='12'>
                        {success === true && (
                            <Alert color='success' fade>
                                Success!
                            </Alert>
                        )}
                        {success === false && (
                            <Alert color='danger' fade>
                                Error!
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default RoleDetails;